import { InviteLinkDialog as SharedInviteLinkDialog } from "@tabipla/components";
import {
  useGroupInvitations,
  useCreateInvitation,
  useDeleteInvitation,
} from "../../application/hooks/useInvitations";

interface InviteLinkDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  groupId: string;
  groupName?: string;
}

export function InviteLinkDialog({
  open,
  onOpenChange,
  groupId,
  groupName,
}: InviteLinkDialogProps) {
  const { data: invitations, isLoading } = useGroupInvitations(groupId);
  const createMutation = useCreateInvitation(groupId);
  const deleteMutation = useDeleteInvitation(groupId);

  return (
    <SharedInviteLinkDialog
      open={open}
      onOpenChange={onOpenChange}
      groupName={groupName}
      invitations={invitations}
      isLoading={isLoading}
      onCreateInvitation={createMutation.mutateAsync}
      isCreating={createMutation.isPending}
      onDeleteInvitation={deleteMutation.mutateAsync}
      isDeleting={deleteMutation.isPending}
      // Waritto-specific messages (bill splitting)
      templateMessage={`「{{groupName}}」の割り勘に参加してね！\n\n登録不要・30秒で参加できるよ👇\n{{url}}`}
      templateMessageNoGroup={`割り勘に参加してね！\n\n登録不要・30秒で参加できるよ👇\n{{url}}`}
      lineShareMessage={`「{{groupName}}」の割り勘に参加してね！登録不要・30秒で参加できるよ✨`}
      lineShareMessageNoGroup={`割り勘に参加してね！登録不要・30秒で参加できるよ✨`}
    />
  );
}
